<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a>T<span class="smallcaps">HE</span> K<span class="smallcaps">EEPER’S</span> S<span class="smallcaps">ON</span></h1>
<p class="image"><img alt="Image" src="images/title.jpg"/></p>
<p class="author">H<span class="small">OMER</span> H<span class="small">ICKAM</span></p>
<p class="editor"><img alt="Image" src="images/pub.jpg"/><br/>St. Martin’s Paperbacks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2235223f